import loadImage from 'blueimp-load-image';

const ImagePromise = src =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(img);
    };

    img.onerror = event => {
      reject(event);
    };

    img.src = src;
  });

export const getCroppedImageBlob = async (src, croppedAreaPixels) => {
  const image = await ImagePromise(src);

  const canvas = document.createElement("canvas");
  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;
  const ctx = canvas.getContext("2d");

  //when image is smaller than predefined crop area (either width or height) do some limiting here to avoid accessing negative positions in original image (which fails in IE)
  let targetY = 0;
  let sourceY = croppedAreaPixels.y;
  let sourceHeight = croppedAreaPixels.height;
  if (image.height < croppedAreaPixels.height) {
    targetY = Math.floor((croppedAreaPixels.height - image.height) / 2);
    sourceY = 0;
    sourceHeight = image.height;
  }

  let targetX = 0;
  let sourceX = croppedAreaPixels.x;
  let sourceWidth = croppedAreaPixels.width;
  if (image.width < croppedAreaPixels.width) {
    targetX = Math.floor((croppedAreaPixels.width - image.width) / 2);
    sourceX = 0;
    sourceWidth = image.width;
  }

  ctx.drawImage(
    image,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    targetX,
    targetY,
    Math.min(croppedAreaPixels.width, sourceWidth),
    Math.min(croppedAreaPixels.height, sourceHeight)
  );

  return new Promise(resolve => {
    canvas.toBlob(blob => {
      resolve(blob);
    }, "image/jpeg");
  });
};


export function fixImageOrientationToBase64(file) {
  return new Promise((resolve, reject) => {
    loadImage(
      file,
      (canvas) => {
        if (canvas.type === "error") {
          reject(new Error("Could not load image"));
        } else {
          // Convert Canvas to base64 string
          const base64 = canvas.toDataURL(file.type || 'image/jpeg');
          resolve(base64);
        }
      },
      {
        orientation: false,
        canvas: true
      }
    );
  });
}